<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header"
               class="card-header"><i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>设备类型</div>
          <div style="overflow:auto;height: calc(100vh - 179px);">
            <el-radio-group v-model="typeSelect">
              <el-row>
                <el-col v-for="item in deviceAllType"
                        :key="item.id"
                        style="height:30px">
                  <el-radio @change="loadAssetExtendDefList()"
                            :label="item.id">{{item.name}}</el-radio>
                </el-col>
              </el-row>
            </el-radio-group>

          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header"
               class="card-header"><i class="el-icon-font el-icon-jiaoseliebiao el-icon--left"></i>扩展字段</div>
          <div class="es-op-box">

            <el-button type="primary"
                       icon="el-icon-font el-icon-web__tianjia"
                       size="mini"
                       style="margin-right:6px"
                       @click="add_init">新增</el-button>
            <es-delete @del="del()"
                       type="button"></es-delete>
          </div>
          <el-table :data="pageData.list"
                    ref="extenddefTable"
                    border
                    stripe
                    size="mini"
                    height="calc(100vh - 250px)"
                    v-loading="loading">
            <el-table-column type="selection"
                             width="40"
                             align="center">
            </el-table-column>
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>
            <el-table-column prop="code"
                             width="120"
                             label="编码">
            </el-table-column>
            <el-table-column prop="label"
                             width="120"
                             label="字段名称">
            </el-table-column>
            <el-table-column prop="type"
                             width="150"
                             label="字段类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 1">文本框</span>
                <span v-if="scope.row.type == 2">下拉框</span>
                <span v-if="scope.row.type == 3">文本域</span>
              </template>
            </el-table-column>
            <el-table-column prop="isRequired"
                             width="120"
                             label="是否必输">
              <template slot-scope="scope">
                <span v-if="scope.row.isRequired == 1">必输</span>
                <span v-if="scope.row.isRequired == 0">不必输</span>
              </template>
            </el-table-column>
            <el-table-column prop="dictFatherName"
                             width="150"
                             label="字典表名称">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 2 ">{{scope.row.dictFatherName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="maxSize"
                             label="最大长度">
              <template slot-scope="scope">
                <span v-if="scope.row.type != 2 ">{{scope.row.maxSize}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作"
                             width="120"
                             align="center">
              <template slot-scope="scope">
                <el-link :underline="false"
                         title="编辑"
                         @click="edit_init(scope.row)"
                         type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete @del="del(scope.row.id)"
                           :key="scope.row.id"
                           type="icon"></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
                           @change="(cpage)=>{this.queryObj.pageNum=cpage;this.loadAssetExtendDefList()}">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--编辑用户-->
    <el-dialog :visible.sync="editVisible"
               @closed="()=>this.$refs['extenddefForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑用户
      </span>
      <el-form :model="extenddefInfo"
               :rules="editRules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="extenddefForm">
        <el-form-item prop="code"
                      label="编码">
          <el-input v-model="extenddefInfo.code"
                    placeholder="请输入编码"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>

        <el-form-item prop="label"
                      label="扩展字段名称">
          <el-input v-model="extenddefInfo.label"
                    placeholder="请输入名称"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="type"
                      label="字段类型">
          <el-select v-model="extenddefInfo.type"
                     @change="externtypeinit()"
                     placeholder="请选择扩展字段类型">
            <el-option v-for="item in externtype"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="isRequired"
                      label="是否必输">
          <el-select v-model="extenddefInfo.isRequired"
                     placeholder="请选择内容是否必输">
            <el-option v-for="item in isRequireds"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="dictVisible==true"
                      prop="dictFatherId"
                      label="字典表名称">
          <el-select v-model="extenddefInfo.dictFatherId"
                     placeholder="">
            <el-option v-for="item in dictfathers"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="maxSize"
                      v-if="maxVisible==true"
                      label="最大长度">
          <el-input-number v-model="extenddefInfo.maxSize"
                           style="width:200px"
                           max="100"
                           controls-position="right"></el-input-number>

        </el-form-item>

      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitExtenddef()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'extenddef',
  props: ["funcs"],
  data () {
    return {

      typeSelect: 1,
      deviceAllType: [],
      dictfathers: [],
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      editVisible: false,

      extenddefInfo: {},//设备扩展字段信息    

      isRequireds: [
        { value: 1, label: "是" },
        { value: 0, label: "否" }
      ],

      externtype: [
        { value: 1, label: "文本框" },
        { value: 2, label: "下拉框" },
        { value: 3, label: "文本域" }
      ],

      dictVisible: true,
      maxVisible: true,


      editRules: {//验证条件
        code: [
          { required: true, message: '请输入编码', trigger: 'blur' },
          { max: 20, message: '不能超过20个字符', trigger: 'blur' }
        ],
        label: [
          { required: true, message: '请输入扩展字段名称', trigger: 'blur' },
          { max: 20, message: '不能超过20个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择合适的扩展字段类型', trigger: 'blur' },
        ],
        isRequired: [
          { required: true, message: '请选择是否必输', trigger: 'blur' },
        ],

        dictFatherId: [
          { required: true, message: '请选择字典列表名称', trigger: 'blur' },
        ],

        maxSize: [
          { required: true, message: '请输入字段长度', trigger: 'blur' },
        ],


      },

      loading: false,
      saving: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadAssetExtendDefList()
      this.initDevicetype()
      this.initdictfathers()
    },

    initDevicetype () {
      this.loading = true
      this.$ajax.get('/base/assettype/list_all', this.queryObj).then(msg => {
        this.deviceAllType = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    initdictfathers () {
      this.loading = true
      this.$ajax.get('/base/dic/listfathersall', this.queryObj).then(msg => {
        this.dictfathers = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    //从后台查询指定设备类型扩展字段列表
    loadAssetExtendDefList () {
      this.loading = true
      this.queryObj.type_id = this.typeSelect
      this.$ajax.get('/base/extenddef/list', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    //初始化添加账户
    add_init () {
      this.editVisible = true
      this.extenddefInfo = {}

      this.extenddefInfo.type = 1
      this.externtypeinit()

    },
    //初始化编辑账户
    edit_init (row) {

      this.extenddefInfo = JSON.parse(JSON.stringify(row))
      this.externtypeinit()
      this.editVisible = true
      console.log(this.extenddefInfo);
    },

    externtypeinit () {
      if (this.extenddefInfo.type == 1 || this.extenddefInfo.type == 3) {
        this.dictVisible = false
        this.maxVisible = true
      }

      if (this.extenddefInfo.type == 2) {
        this.dictVisible = true
        this.maxVisible = false
      }
    },



    //保存账户信息
    submitExtenddef () {
      this.$refs["extenddefForm"].validate(valid => {
        if (valid) {


          this.extenddefInfo.typeId = this.typeSelect
          if (this.extenddefInfo.type == 2 && this.dictfathers != null) {
            for (var item of this.dictfathers) {
              if (item.id === this.extenddefInfo.dictFatherId) {
                this.extenddefInfo.dictFatherName = item.name
                break
              }
            }
          }

          console.log(this.extenddefInfo)

          let extenddef = JSON.parse(JSON.stringify(this.extenddefInfo))
          let url = "/base/extenddef/add";
          if (extenddef.id != null) {
            url = "/base/extenddef/edit";
          }
          this.saving = true
          this.$ajax.post(url, extenddef).then(msg => {
            this.saving = false
            this.loadAssetExtendDefList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除用户信息
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["extenddefTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/base/extenddef/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadAssetExtendDefList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },

  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
</style>
